(function () {

  'use strict';

  eclipseApp.factory('prepaidAirtimeBalanceService', function() {

    var airTimeBalance = null,
      expiryDate = null;

    function setAirTimeBalance(data) {
      airTimeBalance = data;
    }

    function getAirTimeBalance() {
      return airTimeBalance;
    }

    function setExpiryDate(data) {
      expiryDate = data;
    }

    function getExpiryDate() {
      return expiryDate;
    }

    return {
      setAirTimeBalance: setAirTimeBalance,
      getAirTimeBalance: getAirTimeBalance,
      setExpiryDate: setExpiryDate,
      getExpiryDate: getExpiryDate
    };

  });

})();
